import React, { Component } from "react";
import { Button, Modal, Card, Icon, Grid } from "semantic-ui-react";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { searchPatientsMyLab } from "services/patient";
import { displayGender, displayGenderText } from "utils/displayGender";
import displayName from "utils/displayName";
import debounce from "lodash.debounce";
import moment from "moment";
import SearchPatient from "../../../../components/SearchPatient/index";

const schemaValidation = Yup.object().shape({
	patient: Yup.object().shape({ id: Yup.number().min(1, "Champs requis") }),
});

class ChangePatientModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			patientLoading: false,
		};
	}

	filterPatients = debounce((searchTerm, callback) => {
		const { generalParameters } = this.props;
		this.props
			.searchPatientsMyLab({ multiple_search: searchTerm }, 20, 0)
			.then(() => {
				this.setState({ patientLoading: false });
				callback(
					this.props.patients.search?.list?.map((patient) => {
						return {
							id: patient.id,
							mylabId: patient.id,
							label: `CNS ${patient.cns || patient.matricule || ""} - ${displayGenderText(patient, generalParameters.data)} ${
								patient.last_name || ""
							} ${patient.first_name} né(e) ${patient.birth_name || ""} le ${moment(patient.birth_date).format(
								process.env.REACT_APP_DATE_DISPLAY_FORMAT
							)} - ${moment().diff(patient.birth_date, "years")} ans ${patient.mobile_phone || ""} ${patient.email || ""}`,
							...patient,
						};
					})
				);
			})
			.catch((error) => {
				this.setState({ patientLoading: false });
				callback(error);
			});
	}, 500);

	render() {
		const { open, close, submit, newPatient, t } = this.props;

		return (
			<Modal size="large" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
				<Modal.Header>Changer de patient</Modal.Header>
				<Formik
					enableReinitialize
					initialValues={{
						patient: { id: 0 },
					}}
					validationSchema={schemaValidation}
					onSubmit={(values) => {
						submit(values.patient);
						close();
					}}
				>
					{({ submitForm, values, setFieldValue }) => (
						<>
							<Modal.Content>
								<SearchPatient
									placeholder="Sélectionner un patient"
									isSelectSearch
									selectCallback={(value) => {
										setFieldValue("patient", value);
										submitForm();
									}}
									addNewPatientCallback={() => {
										close();
										newPatient();
									}}
								/>
								<Field name="patient" component="input" type="hidden" />
								<Card style={{ width: "100%" }}>
									{values.patient.id !== 0 && (
										<Card.Content>
											<Grid>
												<Grid.Row style={{ width: "100%" }}>
													<Grid.Column mobile={16} tablet={6} computer={6}>
														<div>
															<b>
																{displayGender(values.patient, this.props.generalParameters.data)} {displayName(values.patient)}
															</b>
															<br />
															{values.patient.birth_date && (
																<span style={{ fontSize: "0.8em", fontStyle: "italic" }}>
																	{moment().diff(values.patient.birth_date, "years")} {t("foldersOverview.years")}
																</span>
															)}
														</div>
													</Grid.Column>

													<Grid.Column mobile={16} tablet={6} computer={6} style={{}}>
														{values.patient.birth_date && (
															<b style={{ fontSize: "0.8em" }}>
																{" "}
																{t(values.patient.gender === "f" ? "foldersOverview.bornF" : "foldersOverview.bornM")}
																{t("foldersOverview.the")}
																{moment(values.patient.birth_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}
															</b>
														)}
													</Grid.Column>

													<Grid.Column mobile={16} tablet={6} computer={4} style={{}}>
														<div>
															<b style={{ fontSize: "0.8em" }}>
																{t("foldersOverview.number")}
																{values.patient.cns}
															</b>
														</div>
														{values.patient.active && (
															<span style={{ fontSize: "0.8em" }}>
																<Icon name="heart" /> {t("foldersOverview.actifMylab")}
															</span>
														)}
													</Grid.Column>
												</Grid.Row>
											</Grid>
										</Card.Content>
									)}
								</Card>
							</Modal.Content>

							<Modal.Actions>
								<Button
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										close();
									}}
								>
									Annuler
								</Button>
								<Button
									primary
									disabled={values.patient.id === 0}
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										submitForm();
									}}
								>
									Confirmer
								</Button>
							</Modal.Actions>
						</>
					)}
				</Formik>
			</Modal>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		patients: state.patients,
		generalParameters: state.generalParameters,
	};
};

const mapDispatchToProps = {
	searchPatientsMyLab,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePatientModal);
